import type { DirectorHoverProfile } from './DirectorHoverCard.types';

/**
 * Narrows a FULL management profile row to the hover card's slim shape.
 *
 * Related Party, Regulatory Checks and Director Bureau get this projection from polus
 * (`slimDirectorProfile` in DataTransformationScript.groovy) because their rows are not profiles.
 * The Management Profile tab is the one surface whose rows ARE the profile already, so it projects
 * here instead of paying for a join it does not need — the field list and the customFields-first
 * fallback order are deliberately the same as the Groovy helper's, so the card cannot tell the two
 * sources apart.
 */
export function toDirectorHoverProfile(row: any): DirectorHoverProfile | undefined {
    if (!row) return undefined;
    const customFields = row.customFields ?? {};
    return {
        din: row.din,
        name: row.name,
        designation: row.designation,
        isActive: row.isActive,
        dob: row.dob,
        age: row.age,
        gender: row.gender,
        shareholdingPercentage: row.shareholdingPercentage,
        tenureBeginDate: row.tenureBeginDate,
        tenureEndDate: row.tenureEndDate,
        linkedinUrl: customFields.linkedinUrl || row.linkedinUrl,
        headline: customFields.headline || row.subTitle,
        followersCount: customFields.followersCount ?? row.followersCount,
        imageUrl: customFields.imageUrl || row.imageUrl,
        currentEntitiesCount: Array.isArray(row.currentEntities) ? row.currentEntities.length : 0,
        formerEntitiesCount: Array.isArray(row.formerEntities) ? row.formerEntities.length : 0,
    };
}
